import merge from 'deepmerge'
import ProductMessages from './messages/ProductMessages'
import OrderMessages from './messages/OrderMessages'
import OrderStateMessages from './messages/OrderStateMessages'
import IngredientMessages from './messages/IngredientMessages'
import ProductCategoryMessages from './messages/ProductCategoryMessages'
import BranchMessages from './messages/BranchMessages'
import StockMessages from './messages/StockMessages'
import StockTransactionMessages from './messages/StockTransactionMessages'
import DailyBoxMessages from './messages/DailyBoxMessages'
import PromoMessages from './messages/PromoMessages'
import SurveysMessages from './messages/SurveysMessages'
import CouponMessages from './messages/CouponMessages'


const messages = merge.all([
    ProductMessages,
    OrderMessages,
    OrderStateMessages,
    IngredientMessages,
    ProductCategoryMessages,
    BranchMessages,
    StockMessages,
    StockTransactionMessages,
    DailyBoxMessages,
    PromoMessages,
    SurveysMessages,
    CouponMessages
])

export default messages;
